/**
 * 64px status circle for terminal/waiting screens (kyc-app icon-circle port).
 * Inline SVG so the glyphs render identically across platforms — no emoji, no
 * icon dependency.
 */
interface StatusGlyphProps {
  kind: 'success' | 'error' | 'wait';
}

const PATHS: Record<StatusGlyphProps['kind'], ReturnType<typeof path>> = {
  success: path('M5 13.5 10 18.5 19 7'),
  error: path('M7 7 17 17 M17 7 7 17'),
  wait: path('M12 7v5l3.5 2.5 M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z'),
};

function path(d: string) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d={d} stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function StatusGlyph({ kind }: StatusGlyphProps) {
  return <div className={`glyph glyph--${kind}`}>{PATHS[kind]}</div>;
}
